import React from 'react';
import { TaskStatus } from '../../../../../../../ReactSharedScripts/modules/activity/activityTaskList/const';
import { codes } from '../../../../../../../ReactSharedScripts/data/translations';
import { pink, yellow, green } from '../../../../../../../ReactSharedScripts/components/Color/colors';
import classes from './styles/index.module.scss';
import { useTranslationAPI } from '../../../../../../../ReactSharedScripts/modules/translations';

type TaskListBoardColumnHeaderProps = {
	length: number;
	entityStateId: TaskStatus;
};

const viewConfig = {
	[TaskStatus.ToDo]: {
		code: codes.activity.todo,
		color: pink[7],
	},
	[TaskStatus.InProgress]: {
		code: codes.activity.inProgress,
		color: yellow[7],
	},
	[TaskStatus.Done]: {
		code: codes.activity.done,
		color: green[7],
	},
};

const TaskListBoardColumnHeader: React.FC<TaskListBoardColumnHeaderProps> = ({ entityStateId, length }) => {
	const { translate } = useTranslationAPI();
	const { code, color } = viewConfig[entityStateId];

	return (
		<div
			className={classes.taskBoardColumnHeader}
			style={{ background: `${color}` }}
		>
			{translate(code)} • {length}
		</div>
	);
};

export { TaskListBoardColumnHeader };
